import { useState } from 'react';
import { get } from '../../services/api';
import FiltrosPontuacaoGeral from '../../components/FiltrosPontuacaoGeral/FiltrosPontuacaoGeral';
import TabelaPontuacaoGeral from '../../components/TabelaPontuacaoGeral/TabelaPontuacaoGeral';
import { format } from 'date-fns';

export default function PontuacaoGeral() {
    const [pontuacao, setPontuacao] = useState(null);
    const [carregando, setCarregando] = useState(false);

    const [filtros, setFiltros] = useState({
        periodo: format(new Date, 'MM/yyyy'),
        regiao: 0,
        idfilial: 0,
        tipo_pontuacao: 0,
        variante_pontuacao: 1,
        matricula: '',
        nome: '',
    })
    const [page, setPage] = useState(1)
    
    const getPontuacao = async (mes, ano, regiao, idfilial, tipo_pontuacao, variante_pontuacao, page, matricula, nome ) => {
        const max = 20
        const authToken = localStorage.getItem('adminToken');
        setCarregando(true);
        const res = await get(
            `/admin/pontuacaogeral?mes=${mes}&ano=${ano}&regiao=${regiao}&idfilial=${idfilial}&tipo_pontuacao=${tipo_pontuacao}&variante_pontuacao=${variante_pontuacao}&matricula=${matricula}&nome=${nome}&page=${page}&max=${max}`,
            null,
            authToken
        );

        setPontuacao(res);
        setCarregando(false);
    };

    return (
        <>
            <FiltrosPontuacaoGeral 
                filtros={filtros} 
                setFiltros={setFiltros} 
                resetPage={() => setPage(1)}
                resetRuntimeFilter={() => setFiltros(filtros => ({ ...filtros, nome: '', matricula: '' }))}
                getPontuacao={getPontuacao} />
            {carregando && !pontuacao && <div className='text-center'>Carregando...</div>}
            {pontuacao &&
                <TabelaPontuacaoGeral
                    carregando={carregando} 
                    pontuacao={pontuacao} 
                    matricula={filtros.matricula}
                    setMatricula={(newMatricula) => setFiltros(filtros => ({ ...filtros, matricula: newMatricula }))}
                    nome={filtros.nome}
                    setNome={(newNome) => setFiltros(filtros => ({ ...filtros, nome: newNome }))}
                    setPontuacaoByNomeAndMatricula={(matricula, nome) => {
                        setPage(1)
                        getPontuacao(
                            filtros.periodo.split('/')[0],
                            filtros.periodo.split('/')[1],
                            filtros.regiao,
                            filtros.idfilial,
                            filtros.tipo_pontuacao,
                            filtros.variante_pontuacao,
                            1,
                            matricula,
                            nome
                        )
                    }} 
                    setPontuacaoByPage={(newPage) => getPontuacao(
                        filtros.periodo.split('/')[0],
                        filtros.periodo.split('/')[1],
                        filtros.regiao,
                        filtros.idfilial,
                        filtros.tipo_pontuacao,
                        filtros.variante_pontuacao,
                        newPage,
                        filtros.matricula,
                        filtros.nome
                        )
                    } 
                    page={page} 
                    setPage={setPage} 
                    filtros={filtros}
                />}
        </>
    );
}
